export default __webpack_public_path__ + "static/media/Whats-next.533f7c64.svg";